import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { isNotUndefined, protoKeys } from "@faire/web--source/common/typescriptUtils";
import { isLocal } from "@faire/web--source/common/user-agent/isLocal";
import differenceWith from "lodash/differenceWith";
import includes from "lodash/includes";
import isArray from "lodash/isArray";
import isEqual from "lodash/isEqual";
import isEqualWith from "lodash/isEqualWith";
import isObject from "lodash/isObject";
import omitBy from "lodash/omitBy";
import pickBy from "lodash/pickBy";
import toPairs from "lodash/toPairs";
var PROPS_TO_COMPARE = function() {
    var allProps = {
        baseUrl: true,
        method: true,
        url: true,
        data: true,
        params: true,
        responseType: true,
        subdomain: true,
        withCredentials: true
    };
    return new Set(protoKeys(allProps));
}();
var shouldCompareProp = function(prop, val) {
    return PROPS_TO_COMPARE.has(prop) && isNotUndefined(val);
};
var isDeepEqualIgnoringUndefined = function(a, b) {
    if (!isObject(a) || !isObject(b) || isArray(a) || isArray(b)) {
        return undefined;
    } else if (!includes(a, undefined) && !includes(b, undefined)) {
        return undefined;
    }
    // Call recursively, after filtering all undefined properties
    return isEqualWith(omitBy(a, function(value) {
        return typeof value === "undefined";
    }), omitBy(b, function(value) {
        return typeof value === "undefined";
    }), isDeepEqualIgnoringUndefined);
};
export var isSameRequest = function(a, b) {
    // Efficient early bail.
    if (a.url !== b.url) {
        return false;
    }
    return isEqualWith(pickBy(a, function(v, k) {
        return shouldCompareProp(k, v);
    }), pickBy(b, function(v, k) {
        return shouldCompareProp(k, v);
    }), isDeepEqualIgnoringUndefined);
};
export var emitDifferences = function(request, prefetchRequest) {
    if (!isLocal()) {
        return;
    }
    var differences = differenceWith(toPairs(prefetchRequest).filter(function(param) {
        var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
        return shouldCompareProp(k, v);
    }), toPairs(request).filter(function(param) {
        var _param = _sliced_to_array(param, 2), k = _param[0], v = _param[1];
        return shouldCompareProp(k, v);
    }), isEqual);
    var otherDifferences = differences.filter(function(d) {
        return d[0] !== "data";
    });
    if (otherDifferences.length) {
        // eslint-disable-next-line no-console
        console.log("RequestOptions differences", otherDifferences);
    }
    var dataDifferences = differences.find(function(d) {
        return d[0] === "data";
    });
    if (dataDifferences) {
        // eslint-disable-next-line no-console
        console.log("Request data differences", differenceWith(toPairs(prefetchRequest.data), toPairs(request.data), isEqual));
    }
};
